import { render, staticRenderFns } from "./GenerarReceta.vue?vue&type=template&id=2be680c9&"
import script from "./GenerarReceta.vue?vue&type=script&lang=js&"
export * from "./GenerarReceta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports